var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RouterLink',{attrs:{"to":_vm.to}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.urls.display)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }